import styled from "styled-components";
import React, { useState } from 'react';
import { labelStyles } from "./ui";

const GenderBox = ({ name, setPayload, value }) => {
  const [val, setVal] = useState(value);
  
  const handleChange = (e) => {
    setVal(e.target.value);
    setPayload(e.target.name, e.target.value);
  };

  return (
    <Content role="radiogroup" aria-labelledby={ `${name}_title` }>
      <Title id={ `${name}_title` }>Gender</Title>
      <Options>
        <Input
          type = 'radio'
          name = { name }
          value = 'MALE'
          id= 'male'
          checked = { val === 'MALE' }
          onChange= { e => { handleChange(e) } }
        />
        <Label htmlFor='male'>Male</Label>
        <Input
          type = 'radio'
          name = { name }
          value = 'FEMALE'
          id = 'female'
          checked = { val === 'FEMALE' }
          onChange= { e => { handleChange(e) } }
        />
        <Label htmlFor='female'>Female</Label>
      </Options>
    </Content>
  );
};

const Content = styled.div`
  margin-bottom: 16px;
`;

const Title = styled.span`
  ${labelStyles}
`;

const Options = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 5px;
  border-radius: var(--radius-pill);
  background: var(--surface-tint);
  border: 1.5px solid var(--border);
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;

  &:checked + label {
    background: var(--surface);
    color: var(--text);
    box-shadow: 0 4px 14px -6px rgb(36 48 94 / 0.35);
  }

  &:focus-visible + label {
    outline: 3px solid var(--coral);
    outline-offset: 2px;
  }
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  border-radius: var(--radius-pill);
  font-weight: 600;
  font-size: 15px;
  color: var(--text-muted);
  cursor: pointer;
  transition:
    background-color 0.3s var(--ease-out),
    color 0.2s ease,
    box-shadow 0.3s var(--ease-out);
`;

export default GenderBox;
